import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel, Tc, TcAnno, EnumIdsTcPais, TcNumeroSemana } from '../../../../core/_infrastructure/types/common';
import { CargasSolicitudesPcfExService } from '../cargassolicitudespcfex.service';
import { FilterSearchingCargasSolicitudesPcfExViewModel, CargasSolicitudesPcfExItemResultsViewModel } from '../cargassolicitudespcfex.types';

@Component({
    selector: 'app-cargassolicitudespcfex-wrapper',
    templateUrl: './cargassolicitudespcfex-wrapper.component.html',
})
export class CargasSolicitudesPcfExWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    listCargasSolicitudesPcfEx: CargasSolicitudesPcfExItemResultsViewModel | null;
    edition = false;

    listPuntoInspeccion: Tc[] | null;
    listAnno: TcAnno[] | null;
    listNumeroSemana: TcNumeroSemana[] | null;

    modelosCf: Tc[];

    private route = 'mantenimiento/general/cargassolicitudespcfex';

    payload?: FilterSearchingCargasSolicitudesPcfExViewModel;
    paisEspania = 0;

    constructor(
        protected notificacionService: NotificationService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private pifService: CargasSolicitudesPcfExService,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.paisEspania = parseInt(this.getConfig().IdPaisEspania);

        this.getPcf();

        this.getAnno();

        this.recoverLastSearch();
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.payload = this.pifService.getLastSearch();
    }

    /**
     * Invoca a un método global de la API para obtener la lista de países
     * @return void
     */
    private getPcf(): void {
        this.globalService.getPuntoInspeccionByPaisReasignable(EnumIdsTcPais.ID_ESPANA).subscribe(res => {
            this.listPuntoInspeccion = res;
        });
    }

    private getAnno(): void {
        this.pifService.getAnnosCargas().subscribe(res => {
            this.listAnno = res;
        });
    }

    onSearch(payload: FilterSearchingCargasSolicitudesPcfExViewModel): void {
        if (!payload) {
            return;
        }
        this.payload = { ...payload } as FilterSearchingCargasSolicitudesPcfExViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.pifService.getList(payload).subscribe((results: CargasSolicitudesPcfExItemResultsViewModel) => {
            this.listCargasSolicitudesPcfEx = results;
            this.searching = true;
        });
    }

    onSelectAnno(idAnno: number) {
        this.pifService.getNumeroSemana(idAnno).subscribe((result: TcNumeroSemana[]) => {
            this.listNumeroSemana = result;
        });
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingCargasSolicitudesPcfExViewModel;
        this.onSearch(payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onCleanForm(): void {
        this.searching = false;
        this.listCargasSolicitudesPcfEx = null;
        this.pifService.resetFilter();
    }

    /**
     * Redirigimos al formulario de creación de una nuevo pif
     * @return void
     */
    //onAdd(): void {
    //    this.edition = true;

    //    this.router.navigate([this.route + '/create']);
    //}

    /**
    

    /**
     * Invoked when the user wants to export the result to excel
     * @return void
     */
    onExportExcel(): void {
        this.visibilitySpinner = true;

        let model: FilterSearchingCargasSolicitudesPcfExViewModel = new FilterSearchingCargasSolicitudesPcfExViewModel();
        Object.assign(model, this.payload);

        this.pifService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.listCargasSolicitudesPcfEx?.ResultList ? this.listCargasSolicitudesPcfEx?.ResultList?.length > 0 : false;
    }
}
